<template>
	<div class="navigation">
		<router-link to="/" class="home-navigation" @click.native="toggleBar"><h2>Solfile</h2></router-link>
		<h4 class="navigation-title">Users</h4>
		<router-link class="nav-item" to="/individuals" @click.native="toggleBar">Individuals</router-link>
		<h4 class="navigation-title">Content</h4>
		<router-link class="nav-item" to="/footprint" @click.native="toggleBar">Footprint</router-link>
		<router-link class="nav-item" to="/aspect" @click.native="toggleBar">Aspect</router-link>
		<router-link class="nav-item" to="/retrograde" @click.native="toggleBar">Retrograde</router-link>
		<router-link class="nav-item" to="/discovery" @click.native="toggleBar">Discovery</router-link>
		<h4 class="navigation-title">Settings</h4>
		<router-link class="nav-item" to="/admin-account" @click.native="toggleBar">Account</router-link>
		<a href="#" class="nav-item" @click.prevent="signOut">Sign Out</a>
	</div>
</template>

<script>
export default {
	name: "nav-bar",
	methods: {
		signOut: function () {
			this.$store.dispatch('logoutUser', false)
				.then(() => {
						this.$router.push('/login');
					}
				)
		},
		toggleBar() {
			if (window.innerWidth < 767)
				this.$emit('toggleNavBar')
		}
	}
}
</script>

<style scoped lang="scss">

.navigation {
	text-align: left;

	.home-navigation {
		background-color: white;

		a {
			color: #35495e;
		}

		&.router-link-exact-active {
			a {
				color: #42b883;
			}
		}

		display: block;

		h2 {
			padding: 25px 15px;
			margin: 0;
		}
	}

	.navigation-title {

		&:first-of-type {
			margin-top: 80px;
		}

		margin-top: 30px;
		margin-left: 10px;
	}

	.nav-item {
		padding: 10px 0 10px 10px;
		display: block;

		&.router-link-active,
		&:hover {
			box-shadow: 8px 0 7px 0 #c1b6b6;
			background-color: #ffffff;
		}
	}
}

</style>
